
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.36 24.36v-6.72H21v6.72h3.36zm-6.72 0V7.64h-3.28v16.72h3.28zm-6.64 0V12.64H7.64v11.72H11zM27.64 1c.907 0 1.693.333 2.36 1 .667.667 1 1.453 1 2.36v23.28c0 .907-.333 1.693-1 2.36-.667.667-1.453 1-2.36 1H4.36c-.907 0-1.693-.333-2.36-1-.667-.667-1-1.453-1-2.36V4.36c0-.907.333-1.693 1-2.36.667-.667 1.453-1 2.36-1h23.28z"}})])
          )
        }
      }
    